import { Minus, Plus } from "lucide-react";

export const NumberStepper = ({ value, onChange, min = 0, max = 99, compact = false, testId, className = "" }) => {
  const v = Number(value) || 0;
  const btn = compact ? "w-8 h-8" : "w-11 h-[46px]";
  const icon = compact ? "w-3 h-3" : "w-4 h-4";
  return (
    <div
      className={`inline-flex items-stretch border border-[hsl(var(--border))] bg-white select-none ${compact ? "" : "w-full"} ${className}`}
      data-testid={testId}
    >
      <button
        type="button"
        aria-label="Azalt"
        disabled={v <= min}
        onClick={() => onChange(Math.max(min, v - 1))}
        className={`${btn} flex items-center justify-center shrink-0 text-[hsl(var(--ink))] disabled:opacity-25 hover:bg-[hsl(var(--surface))] active:bg-[hsl(var(--surface))] transition-colors`}
        data-testid={testId ? `${testId}-dec` : undefined}
      >
        <Minus className={icon} />
      </button>
      <span
        className={`flex-1 flex items-center justify-center font-medium tabular-nums border-x border-[hsl(var(--border))] ${compact ? "text-xs min-w-[2rem] px-1" : "text-sm px-2"}`}
        data-testid={testId ? `${testId}-value` : undefined}
      >
        {v}
      </span>
      <button
        type="button"
        aria-label="Artır"
        disabled={v >= max}
        onClick={() => onChange(Math.min(max, v + 1))}
        className={`${btn} flex items-center justify-center shrink-0 text-[hsl(var(--ink))] disabled:opacity-25 hover:bg-[hsl(var(--surface))] active:bg-[hsl(var(--surface))] transition-colors`}
        data-testid={testId ? `${testId}-inc` : undefined}
      >
        <Plus className={icon} />
      </button>
    </div>
  );
};
